import { IconProps } from "./icon.type";

export function IcGlassPersonal(props: IconProps) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3200_45425)">
        <rect width="40" height="40" rx="8" fill="white" />
        <g clipPath="url(#clip1_3200_45425)">
          <rect width="40" height="40" fill="white" />
          <foreignObject x="-99.0996" y="-99.1001" width="239" height="239">
            <div
              style={{
                backdropFilter: "blur(36.75px)",
                clipPath: "url(#bgblur_2_3200_45425_clip_path)",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </foreignObject>
          <circle
            data-figma-bg-blur-radius="73.5"
            cx="20.4004"
            cy="20.3999"
            r="46"
            fill="url(#paint0_radial_3200_45425)"
            fillOpacity="0.15"
          />
          <path
            d="M34.084 29.6034C33.4174 26.165 30.391 23.5701 26.7564 23.5701C23.1217 23.5701 20.0953 26.165 19.4287 29.6034C19.2842 30.3455 19.8709 31.0336 20.6259 31.0336H32.8846C33.6418 31.0336 34.2263 30.3476 34.0818 29.6034H34.084Z"
            fill="url(#paint1_linear_3200_45425)"
          />
          <path
            d="M26.7559 21.8163C28.8026 21.8163 30.4618 20.1571 30.4618 18.1104C30.4618 16.0637 28.8026 14.4045 26.7559 14.4045C24.7092 14.4045 23.05 16.0637 23.05 18.1104C23.05 20.1571 24.7092 21.8163 26.7559 21.8163Z"
            fill="url(#paint2_linear_3200_45425)"
          />
          <path
            d="M26.7559 21.8163C28.8026 21.8163 30.4618 20.1571 30.4618 18.1104C30.4618 16.0637 28.8026 14.4045 26.7559 14.4045C24.7092 14.4045 23.05 16.0637 23.05 18.1104C23.05 20.1571 24.7092 21.8163 26.7559 21.8163Z"
            fill="url(#paint3_linear_3200_45425)"
          />
          <foreignObject x="-5.90844" y="10.2202" width="41.3398" height="32.27">
            <div
              style={{
                backdropFilter: "blur(5.73px)",
                clipPath: "url(#bgblur_3_3200_45425_clip_path)",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </foreignObject>
          <path
            data-figma-bg-blur-radius="11.4563"
            d="M14.7627 21.8767C19.1915 21.8768 22.883 25.0207 23.7344 29.197L23.751 29.28C23.907 30.0839 23.2739 30.8336 22.4463 30.8337H7.07715C6.2495 30.8337 5.61549 30.0839 5.77148 29.28C6.59053 25.0624 10.3045 21.8767 14.7627 21.8767Z"
            fill="url(#paint4_linear_3200_45425)"
            fillOpacity="0.6"
            stroke="url(#paint5_linear_3200_45425)"
            strokeWidth="0.4"
          />
          <foreignObject x="-1.34179" y="-1.26684" width="32.2031" height="32.2031">
            <div
              style={{
                backdropFilter: "blur(5.73px)",
                clipPath: "url(#bgblur_4_3200_45425_clip_path)",
                height: "100%",
                width: "100%",
              }}
            ></div>
          </foreignObject>
          <path
            data-figma-bg-blur-radius="11.4563"
            d="M13.7392 10.5095C16.1279 9.94593 18.5218 11.4254 19.0856 13.8141C19.6492 16.2027 18.1695 18.5966 15.781 19.1605C13.3923 19.7243 10.9985 18.2446 10.4346 15.8559C9.87077 13.4671 11.3503 11.0734 13.7392 10.5095Z"
            fill="url(#paint6_linear_3200_45425)"
            fillOpacity="0.6"
            stroke="url(#paint7_linear_3200_45425)"
            strokeWidth="0.4"
          />
        </g>
      </g>
      <defs>
        <clipPath id="bgblur_2_3200_45425_clip_path" transform="translate(99.0996 99.1001)">
          <circle cx="20.4004" cy="20.3999" r="46" />
        </clipPath>
        <clipPath id="bgblur_3_3200_45425_clip_path" transform="translate(5.90844 -10.2202)">
          <path d="M14.7627 21.8767C19.1915 21.8768 22.883 25.0207 23.7344 29.197L23.751 29.28C23.907 30.0839 23.2739 30.8336 22.4463 30.8337H7.07715C6.2495 30.8337 5.61549 30.0839 5.77148 29.28C6.59053 25.0624 10.3045 21.8767 14.7627 21.8767Z" />
        </clipPath>
        <clipPath id="bgblur_4_3200_45425_clip_path" transform="translate(1.34179 1.26684)">
          <path d="M13.7392 10.5095C16.1279 9.94593 18.5218 11.4254 19.0856 13.8141C19.6492 16.2027 18.1695 18.5966 15.781 19.1605C13.3923 19.7243 10.9985 18.2446 10.4346 15.8559C9.87077 13.4671 11.3503 11.0734 13.7392 10.5095Z" />
        </clipPath>
        <radialGradient
          id="paint0_radial_3200_45425"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.4004 20.3999) rotate(90.7441) scale(34.3912)"
        >
          <stop stopColor="#F62E6D" />
          <stop offset="1" stopColor="#F76382" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_3200_45425"
          x1="26.7564"
          y1="35.1407"
          x2="26.7564"
          y2="12.7005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6005A" />
          <stop offset="1" stopColor="#F7CBAD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3200_45425"
          x1="26.7559"
          y1="-82.9339"
          x2="26.7559"
          y2="12.7004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6005A" />
          <stop offset="1" stopColor="#F7CBAD" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3200_45425"
          x1="23.4685"
          y1="21.3978"
          x2="30.0434"
          y2="14.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0C0C" stopOpacity="0.49" />
          <stop offset="1" stopColor="#FFA5A5" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3200_45425"
          x1="6.58817"
          y1="30.5057"
          x2="13.2904"
          y2="17.3073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0C0C" stopOpacity="0.49" />
          <stop offset="1" stopColor="#FFA5A5" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3200_45425"
          x1="9.61436"
          y1="33.2599"
          x2="17.4039"
          y2="18.4586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3200_45425"
          x1="11.6964"
          y1="19.7908"
          x2="17.823"
          y2="9.87877"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0C0C" stopOpacity="0.49" />
          <stop offset="1" stopColor="#FFA5A5" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3200_45425"
          x1="13.809"
          y1="22.1012"
          x2="20.8551"
          y2="11.144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_3200_45425">
          <rect width="40" height="40" rx="8" fill="white" />
        </clipPath>
        <clipPath id="clip1_3200_45425">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
